import { type Entity } from "@firecms/core";
import { type Event } from "../collections/events";
import { resolveLocalizedString } from "../localization";

export function eventEntityTitle(entity: Entity<Event>): string {
  return (
    resolveLocalizedString(
      entity.values.title,
      entity.values.mainLocale
    ) || entity.values.name
  );
}
